import { PlayCircle } from "lucide-react";

export function Logo({ size = "text-2xl" }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="app-logo">
      <div className="relative flex items-center justify-center w-9 h-9 rounded-xl bg-[#FF334B] glow">
        <PlayCircle className="w-6 h-6 text-white" strokeWidth={2.2} />
      </div>
      <div className="leading-none">
        <div className={`font-display ${size} tracking-wide`}>
          METÁFORA <span className="text-[#FF334B]">PLAY</span>
        </div>
      </div>
    </div>
  );
}
